import {FPNetDate} from "@commons/types";

export interface SaldoICRecord {
    idAziendaMaster: number,
    idDip: number,
    anno: number,
    mese: number,
    codIstituto: string,

    meseInizioMaturazione: number,
    te: number,
    contrattuale: number,
    residuoAnnoPrec: number,
    incremento: number,
    maturati: number,
    maturatiPrev: number,
    goduti: number,
    residuoMese: number,
    residuoAnno: number,
    godutiPeriodiPrec: number,

    maturatiPeriodo: number,
    godutiPeriodo: number,
    godutiWFAccettate: number, // da wf e pianificazione (ovvero PRESENZE_GIUSTIFICATIVI)
    dtGodutiAl: FPNetDate,
}

export class SaldoICRecord {
    static getPeriodo = function (saldo: SaldoICRecord) {
        return saldo.mese + '/' + saldo.anno;
    };

    static isValid = function (saldo: SaldoICRecord) {
        return saldo.contrattuale > 0 || saldo.residuoMese !== 0;
    };

    static isAttualizzato = function (saldo: SaldoICRecord) {
        var attualizzato = false;
        if (saldo)
            if (((saldo.godutiPeriodiPrec || 0) + (saldo.godutiPeriodo || 0)) > 0) {
                attualizzato = true;
            }
        return attualizzato;
    };

    static getGodutoAttualizzato = function (saldo: SaldoICRecord) {
        return (saldo.goduti || 0) + (saldo.godutiPeriodiPrec || 0) + (saldo.godutiPeriodo || 0);
    };

    static getResiduoMeseAttualizzato = function (saldo: SaldoICRecord) {
        return (saldo.residuoMese || 0) - (saldo.godutiPeriodiPrec || 0) - (saldo.godutiPeriodo || 0);
    };

    static getResiduoAnnoAttualizzato = function (saldo: SaldoICRecord) {
        return (saldo.residuoAnno || 0) - (saldo.godutiPeriodiPrec || 0) - (saldo.godutiPeriodo || 0);
    };

    static isAttualizzatoWF = function (saldo: SaldoICRecord) {
        var attualizzato = false;
        if (saldo)
            if ((saldo.godutiWFAccettate || 0) > 0) {
                attualizzato = true;
            }
        return attualizzato || SaldoICRecord.isAttualizzato(saldo);
    };
    static getGodutoAttualizzatoWF = function (saldo: SaldoICRecord) {
        return (saldo.goduti || 0) + (saldo.godutiPeriodiPrec || 0) + (saldo.godutiPeriodo || 0) + (saldo.godutiWFAccettate || 0);
    };
    static getResiduoMeseAttualizzatoWF = function (saldo: SaldoICRecord) {
        return (saldo.residuoMese || 0) - (saldo.godutiPeriodiPrec || 0) - (saldo.godutiPeriodo || 0) - (saldo.godutiWFAccettate || 0);
    };
    static getResiduoAnnoAttualizzatoWF = function (saldo: SaldoICRecord) {
        return (saldo.residuoAnno || 0) - (saldo.godutiPeriodiPrec || 0) - (saldo.godutiPeriodo || 0) - (saldo.godutiWFAccettate || 0);
    };

    static cercaSaldo = function (codIstituto: string, saldi: SaldoICRecord[]): SaldoICRecord | null {
        for (let ind0 = 0; ind0 < saldi.length; ind0++) {
            if (saldi[ind0].codIstituto === codIstituto) {
                return saldi[ind0];
            }
        }
        return null;
    };

    /**
     * @param te Da programma paghe:
     * tipo esposiozione =0 ferie espresse in ore
     * tipo esposiozione =1 maturazione e pagamento ferie a giorni
     * tipo esposiozione =2 maturazione e pagamento ferie a giorni con godimento a 1,20 giornaliero
     */
    static getTipoEsposizione = function ({te}: SaldoICRecord) {
        return te === 0 ? 'hh' : ((te === 1 || te === 2) ? 'gg' : '??');
    }

}